export default import.meta.ROLLDOWN_FILE_URL_LlkwP5AqLzn2qlmmC5jEtA